<template>
  <v-container>
    <v-row>
      <v-col>
        <router-link
          v-if="yearId"
          class="text-decoration-none"
          :to="{ name: 'AdminYearEdit', params: { yearId: yearId, tabName: 'branches' } }">
          <IndicatorWidget
            :number="yearInfo.branch_count"
            caption="# Branches"
            caption_sm="Branches"></IndicatorWidget>
        </router-link>
      </v-col>
      <v-col v-for="(team, index) in yearInfo.teams" :key="index">
        <router-link
          class="text-decoration-none"
          :to="{ name: 'AdminBranchYearEdit', params: { branchId: team.id, yearId: yearId } }">
          <IndicatorWidget
            :number="team.count"
            :caption="`# Teams for ${team.name}`"
            :caption_sm="team.name"></IndicatorWidget>
        </router-link>
      </v-col>
      <v-col>
        <IndicatorWidget
          :number="yearInfo.registration_fees"
          caption="Revenue"
          caption_sm="Revenue"
          prepend="$"></IndicatorWidget>
      </v-col>
      <v-col>
        <router-link
          v-if="yearId"
          class="text-decoration-none"
          :to="{ name: 'AdminYearTeamIncomplete', params: { yearId: yearId } }">
          <IndicatorWidget
            :number="yearInfo.incomplete_registrations"
            caption="# of Incomplete Registrations"
            caption_sm="Incomplete"></IndicatorWidget>
        </router-link>
      </v-col>
    </v-row>
    <v-row>
      <v-col><TeamsForYearSubView v-if="yearId" :yearId="yearId"></TeamsForYearSubView> </v-col>
    </v-row>
  </v-container>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { useYearStore } from '@/stores/index';
import IndicatorWidget from '@/components/ui/IndicatorWidget.vue';
import TeamsForYearSubView from './subviews/TeamsForYearSubView.vue';
import { YearInfoDTO } from '@/dtos';
const yearStore = useYearStore();
const yearId = computed(() => yearStore.selectedYearId);
const query = yearStore.getYearInfoQuery(yearId);
const yearInfo = computed(() => query.data.value ?? new YearInfoDTO());
</script>
